// (手工提交的)业绩状态字典
const BusinessStatusDict_Manual = [
    {value:'0',text:'未提交'},
    {value:'4',text:'已提交'},
    {value:'2',text:'已退回'},
    {value:'1',text:'已确认'},    
    {value:'3',text:'已匹配'},
   ]

// 外部接口导入 业绩状态字典
const BusinessStatusDict_ThirdParty = [
    {value:'10',text:'补录中'},
    {value:'4',text:'已提交'},
    {value:'11',text:'已确认'},
    {value:'12',text:'已推送开票'},
   ]


// 0未提交 4业绩已提交 1已确认 2已退回 3已匹配 (业绩已推送开票)
const BusinessInfoStatus = {
    UNCONFIRM: "0",
    SUBMIT: "4",
    RETURNED: "2",
    CONFIRMED: "1",    
    MATCHED: "3",

    UNFIX: "10", // 补录中
    //SUBMIT: "4", // 待审核
    READY: "11",//已确认
    PASS: "12", // 已推送开票
}

// 发票状态 0 未推送 1已推送 2 已开票 3已到账 6 已合并
const InvoiceStatus = {
    NOT_SEND: "0",
    SENT: "1",
    INVOICED: "2",
    PAYED: "3",
    MERGED: "6",
}


export {
    BusinessStatusDict_Manual,
    BusinessStatusDict_ThirdParty,

    BusinessInfoStatus,
    InvoiceStatus,
}